import restful, { fetchBackend } from 'restful.js';

import { setLoading } from './actions/loading';
import collections from './constants/collections';
import store from './store';

const api = restful(`${window.location.origin}/api`, fetchBackend(fetch));

api.login = api.custom(collections.login);
api.equipes = api.all(collections.equipes);
api.services = api.all(collections.services);

const logRequest = ['login', 'verifToken'];

/**
 * event action for api call
 * @param {String} event - event name
 * 'request' => before api call
 * 'response' => after api call successful
 * 'error' => after error
 * @param {Object} config - request config (method, data ...)
 */
let timeoutId;
const responsesArr = [];

api.addRequestInterceptor((request) => {
  const { headers, ...config } = request;
  const timestamp = new Date().getTime();
  timeoutId = setTimeout(() =>
    store.dispatch(
      setLoading({
        open: true,
        message: logRequest.some(e => config.url.includes(e)) ?
          'Connexion en cours veuillez patienter' : ''
      })
    ));
  responsesArr.push({ timestamp, timeoutId, ...config });
  return {
    ...config,
    headers: { ...headers, timeoutId, timestamp }
  };
});

api.on('response', (t) => {
  const headers = t.headers();
  const index = responsesArr.findIndex(e =>
    e.timestamp === Number(headers.timestamp) &&
  e.timeoutId === Number(headers.timeoutid)
  );
  if (index > -1) {
    clearTimeout(responsesArr[index].timeoutId);
    responsesArr.splice(index, 1);
  } else {
    clearTimeout(responsesArr[responsesArr.length - 1].timeoutId);
    responsesArr.pop();
  }
  if (!responsesArr.length) {
    store.dispatch(setLoading({ open: false }));
  }
});

api.on('error', () => {
  responsesArr.map(e => clearTimeout(e.timeoutId));
  responsesArr.pop();
  store.dispatch(setLoading({ open: false }));
});

api.subscribe = (store) => {
  store.subscribe(() => {
    const state = store.getState();
    api.header('Authorization', state.token);
  });
};

export default api;
